<script lang="ts">
  import { getContext } from 'svelte'
  import { hexToRgba } from './../../lib/helpers'
  import type { Theme } from 'website_script/types/theme'

  const { neutralTextColor } = getContext<Theme>('theme')

  /** name displayed in the label */
  export let name: string
  /** string with label classnames; Options: with-background|small|label-left */
  export let className: string
</script>

<div
  class={`${className} label`}
  style={`--neutral-text-color: ${neutralTextColor}; --box-shadow-color: ${hexToRgba(
    neutralTextColor,
    0.25
  )} `}
>
  {name}
</div>

<style>
  .label {
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
    color: var(--neutral-text-color);
    background-color: #ffffff;
    font-size: 13px;
    font-weight: 400;
    cursor: pointer;
    font-weight: bold;
    border-radius: 14px;
    box-shadow: 0px 1px 4px var(--box-shadow-color);
    margin-top: 4px;
  }

  .with-background {
    padding: 8px 16px 8px 12px;
    background-color: #f0f6ff;
  }

  .label-left {
    margin-right: 10px;
    position: absolute;
    right: 100%;
  }
  .small {
    font-size: 12px;
    padding: 6px;
  }
</style>
